import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

export default function HeroSection() { console.log("HERO RENDERIZZATA");
 const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // optional scroll behavior can go here
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
useEffect(() => {
  if (menuOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return () => {
    document.body.style.overflow = "auto";
  };
}, [menuOpen]);
  console.log("HERO NUOVO ATTIVO");
  return (
  <>
   <section className="relative min-h-screen w-full overflow-hidden pt-24 md:pt-32">

   {/* BACKGROUND */}
<div className="absolute inset-0 overflow-hidden">

  <video
    autoPlay
    muted
    loop
    playsInline
    className="w-full h-full object-cover object-center scale-105"
  >
    <source src="/videos/hero/hero .mp4" type="video/mp4" />
  </video>

  <div className="absolute inset-0 bg-gradient-to-br from-black/60 via-black/40 to-black/70"></div>

</div>
    {/* MOBILE MENU OVERLAY */}
    {menuOpen && (
      <div className="fixed inset-0 z-[100] 
                      bg-black/60 backdrop-blur-2xl
                      flex flex-col items-center justify-center
                      text-white font-serif text-3xl
                      gap-12 transition-all duration-500">

        {/* CLOSE BUTTON */}
        <button
          onClick={() => setMenuOpen(false)}
          className="absolute top-8 right-8 w-14 h-14 flex items-center justify-center
                     rounded-full bg-white/10 backdrop-blur-xl
                     border border-white/20
                     shadow-[0_8px_30px_rgba(0,0,0,0.3)]
                     hover:scale-110 hover:bg-white/20
                     transition-all duration-300"
        >
          <span className="text-4xl font-light leading-none">×</span>
        </button>

        <a href="#about" onClick={() => setMenuOpen(false)} className="hover:text-alkimya-gold transition-colors">Chi Siamo</a>
        <a href="#services" onClick={() => setMenuOpen(false)} className="hover:text-alkimya-gold transition-colors">Servizi</a>
        <a href="#gallery" onClick={() => setMenuOpen(false)} className="hover:text-alkimya-gold transition-colors">Gallery</a>
        <a href="#reviews" onClick={() => setMenuOpen(false)} className="hover:text-alkimya-gold transition-colors">Recensioni</a>
        <a href="#contact" onClick={() => setMenuOpen(false)} className="hover:text-alkimya-gold transition-colors">Contatti</a>
      </div>
    )}

    {/* HERO CONTENT */}
    <div className="relative z-10 min-h-[85vh] flex flex-col justify-center px-6 sm:px-10 md:px-16 text-center">
      <div className="max-w-4xl mx-auto">

        <h2 className="font-serif font-light text-white
                       text-4xl sm:text-6xl md:text-7xl lg:text-8xl
                       leading-tight tracking-tight mb-8">
          Bellezza Autentica,<br />Risultati Reali
        </h2>

        <p className="font-sans text-base sm:text-lg md:text-xl
                      text-white/90 mb-12 max-w-xl mx-auto leading-relaxed">
          Tecnologie avanzate e protocolli personalizzati<br />
          per la tua trasformazione
        </p>

       <Link
  to="/trattamenti"
  className="
    inline-flex items-center
    px-6 py-4
    rounded-full

    text-white
    font-medium text-base tracking-wide

    bg-white/10 backdrop-blur-xl
    border border-white/20

    shadow-[0_8px_30px_rgba(0,0,0,0.25)]

    hover:bg-white/20
    hover:scale-105
    hover:shadow-[0_10px_40px_rgba(255,255,255,0.15)]

    transition-all duration-300
  "
>
  Scopri i trattamenti
</Link>
      </div>
    </div>
  </section>
  </>
);
}